import * as React from 'react';
import { styled } from '@glitz/react';
import {
  createMaxMobileViewportDecorator,
  createMaxSmallViewportDecorator,
  createMinLargeViewportDecorator,
} from 'webapp/viewport';
import { Document } from '@avensia/excite-contentful';
import { translate } from '@avensia/excite';
import Link from 'webapp/components/Link';

type PropType = {
  brand: string;
  brandLogoUrl: Excite.ContentApi.ImageApiModel;
  brandUrl: string;
  designers?: NordicNest.Api.DesignerInfoApiModel[];
  brandInfo: NordicNest.Api.BrandInfoApiModel | undefined;
};

export const BrandAndDesignerContent = (props: PropType) => {
  return (
    <Container>
      <Info>
        <Heading>{props.brand}</Heading>
        {props.brandInfo?.description && (
          <Description>
            <Document elements={props.brandInfo?.description} />
          </Description>
        )}
        <ShowMoreLink to={props.brandUrl}>{translate(t => t.readMore)}</ShowMoreLink>
      </Info>
      {props.designers &&
        props.designers.map(designer => (
          <Info key={designer.url}>
            <Heading>{designer.name}</Heading>
            {designer.description && <Description>{designer.description as any}</Description>}
            {designer.description && <ShowMoreLink to={designer.url}>{translate(t => t.readMore)}</ShowMoreLink>}
          </Info>
        ))}
    </Container>
  );
};

const Container = styled.div(
  createMaxMobileViewportDecorator({
    gridTemplateColumns: '1fr',
  }),
  {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: t => t.sharedSpacing.xl,
  },
);

const Heading = styled.h3({
  fontSize: t => t.sharedFontSize.m,
  marginBottom: t => t.sharedSpacing.m,
  letterSpacing: 0.085,
});

const Info = styled.div(
  createMaxSmallViewportDecorator({
    marginBottom: t => t.sharedSpacing.xs,
  }),
);

const ellipsisDecorator = styled(
  createMinLargeViewportDecorator({
    WebkitLineClamp: 3,
  }),
  {
    display: '-webkit-box',
    WebkitLineClamp: 5,
    WebkitBoxOrient: 'vertical',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
);

const Description = styled.div(ellipsisDecorator, {
  fontSize: t => t.sharedFontSize.xs,
  marginBottom: t => t.sharedSpacing.m,
  lineHeight: 'normal',
});

const ShowMoreLink = styled(
  Link,
  createMaxSmallViewportDecorator({
    fontSize: t => t.sharedFontSize.xs,
  }),
  {
    fontSize: t => t.sharedFontSize.xxs,
    textDecoration: 'underline',
    ':hover': {
      textDecoration: 'underline',
    },
  },
);
